var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { VisuallyHidden } from 'modules/VisuallyHidden';
import { Falcon } from 'modules/macro';
import { useAccessibilityWarning } from './useAccessibilityWarning';
import { StyledButton } from './styled';
export function CheckButton(props) {
    const { selected = false, size = 'medium', label } = props, restProps = __rest(props, ["selected", "size", "label"]);
    useAccessibilityWarning(props);
    return (<StyledButton $selected={selected} $size={size} aria-pressed={selected} {...restProps}>
      <VisuallyHidden>{label}</VisuallyHidden>
      <Falcon icon="check" $size={12} $color="primary.0"/>
    </StyledButton>);
}
